import { DEMO_CUSTOMER } from "src/app/config/customers/demo.customer";

// Local full-stack (docker compose) — same-origin behind the nginx front door.
// apiUrl is relative so /api proxies to Rails; apiFileUrl is empty so HLS URLs
// (`${apiFileUrl}${chapter.hls_url}`) stay root-relative (/hls/...) and ride the
// same https origin where nginx serves /hls via auth_request. Mirrors eazycal's
// environment.local.ts.
export const environment = {
  appName: "Wise",
  production: false,
  apiUrl: "/api",
  apiFileUrl: "",
  appVersion: "v1.0.0",
  customer: DEMO_CUSTOMER,
};
